/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveConnections from './receive-connections';
import * as actions from 'state/action-types';

export default (connectionId = null, connection) => (dispatch) => {
    const isNew = !connectionId;

    if (isNew) {
        return cecSdk
            .connection()
            .add(connection)
            .then((connection) => {
                dispatch(receiveConnections([connection]));
                dispatch({ type: actions.SAVE_CONNECTION_SUCCESS, payload: { connection, isNew } });
                return connection;
            });
    }

    return cecSdk
        .connection(connectionId)
        .update(connection)
        .then((connection) => {
            dispatch(receiveConnections([connection]));
            dispatch({ type: actions.SAVE_CONNECTION_SUCCESS, payload: { connection } });
        });
};